import { useParams } from 'react-router'
import { VaultWorkbench } from './VaultsPage'

export function VaultDetailPage() {
  const params = useParams()
  return <VaultWorkbench splatPath={params['*']} />
}
